import React, { useEffect } from "react";
import { HideLoader, ShowLoader, toastError, UserToken } from "../utils/helper";
import {
  generatePolicyAsync,
  getPDFPolicyNoAsync,
} from "../redux/slice/termLifeSlice";
import moment from "moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";

const ImeGeneratePolicy = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    payLater();
  }, []);

  const payLater = async () => {
    try {
      ShowLoader();
      await UserToken();

      const response = await dispatch(
        generatePolicyAsync({
          PaymentResponse: searchParams.get("data"),
          //   proposalId: premium.proposalId,
          //   amount: premium.sumAssured,
          collectionType: "V",
          transactionDate: moment().format("YYYY-MM-DD"),
          // paymentMode: "NPX"
        })
      );

      if (response.payload.code === "100") {
        await dispatch(
          getPDFPolicyNoAsync({
            DocId: response.payload.data,
          })
        )
          .unwrap()
          .then((res) => {
            if (res.code === "000") {
              navigate("/report/policy-paper-preview", { state: res.url });

              // window.location.href = res.url;
              // window.open(res.url, "_blank");
              // navigate("/dashboard");
            }
          })
          .catch((err) => { });
      } else {
        toastError(response.payload.message);
        navigate("/dashboard");
      }
    } catch (error) {
      console.error(error);
    } finally {
      HideLoader();
    }
  };
};

export default ImeGeneratePolicy;
